import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { DxDrawerComponent } from 'devextreme-angular';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent implements OnInit {
  @ViewChild(DxDrawerComponent, { static: false }) drawer!: DxDrawerComponent;

  showSubmenuModes: string[] = ['slide', 'expand'];
  positionModes: string[] = ['left', 'right'];
  showModes: string[] = ['push', 'shrink', 'overlap'];
  text!: string;
  selectedOpenMode: string = 'shrink';
  selectedPosition: string = 'left';
  selectedRevealMode: string = 'slide';
  isDrawerOpen = true;
  elementAttr: any;
  navigation = ([] = [
    { id: 1, text: 'Products', icon: 'product' },
    { id: 2, text: 'Sales', icon: 'money' },
    { id: 3, text: 'Customers', icon: 'group' },
    { id: 4, text: 'Employees', icon: 'card' },
    { id: 5, text: 'Reports', icon: 'chart' },
  ]);

  constructor(private router: Router) {}

  toolbarContent = [
    {
      widget: 'dxButton',
      location: 'before',
      options: {
        icon: 'menu',
        onClick: () => (this.isDrawerOpen = !this.isDrawerOpen),
      },
    },
  ];

  ngOnInit(): void {}
}
